import { format, getTime, parse } from 'date-fns';

export const createRange = (
  startAt: number,
  endAt: number,
  duration: number,
): [number, number] => {
  const actualStart = startAt === -1 ? 0 : startAt;
  const actualEnd = endAt === -1 ? duration : endAt;

  const clampedStart = Math.max(0, Math.min(actualStart, duration));
  const clampedEnd = Math.max(clampedStart, Math.min(actualEnd, duration));

  const startPercentage = (clampedStart / duration) * 100;
  const endPercentage = (clampedEnd / duration) * 100;

  return [startPercentage, endPercentage];
};

export const parseStartAt = (value: number): string => {
  if (value < 0) {
    return '00:00:000';
  }
  return parseNumberValue(value);
};

export const parseEndAt = (value: number, duration: number): string => {
  if (value < 0 || value > duration) {
    return parseNumberValue(duration);
  }
  return parseNumberValue(value);
};

export const parseStringValue = (value: string) => {
  const date = parse(value, 'mm:ss:SSS', new Date(0));
  return getTime(date);
};

export const parseNumberValue = (value: number) => {
  if (value < 0) {
    return '00:00:000';
  }
  return format(new Date(value), 'mm:ss:SSS');
};

export const parseRange = ([from, to]: [number, number], duration: number) => {
  const startAt = Math.round((from / 100) * duration);
  const endAt = Math.round((to / 100) * duration);

  return [startAt, endAt];
};
